// removed by extract-text-webpack-plugin
module.exports = {"Title":"Title__30oKF","Inner":"Inner__2ouA7"};